module.exports = __webpack_public_path__ + "static/img/about-a_img.2fa9371.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/about-a_img.png
// module id = TX9Z
// module chunks = 1